module.exports = __webpack_public_path__ + "static/media/loginBackground.339f5a6e.png";